



























































import Vue from 'vue'
import SimpleLoader from '@/components/atoms/SimpleLoader.vue'
import PageTitle from '@/components/atoms/PageTitle.vue'
import Alert from '@/components/atoms/Alert.vue'
import ButtonWrap from '@/components/atoms/ButtonWrap.vue'
import RoundButton from '@/components/atoms/RoundButton.vue'
import ListItem from '@/components/molecules/ListItem.vue'
import { State as UsersState } from '@/store/modules/users'

export default Vue.extend({
  name: 'SettingsMail',
  components: {
    SimpleLoader,
    PageTitle,
    ButtonWrap,
    RoundButton,
    ListItem,
    Alert
  },
  data() {
    return {
      crrent_password: '',
      new_password: '',
      confirm_password: '',
      confirm_validate_frag: false,
      confirm_validate: false
    }
  },
  computed: {
    isPageLoading(): boolean {
      return this.$state.users.isProfileLoading
    },
    profile(): UsersState['profile'] | null {
      return this.$state.users.profile
    }
  },
  methods: {
    onValidate() {
      if (this.confirm_validate_frag) {
        this.confirm_validate = this.new_password !== this.confirm_password
      }
    },
    changeValidateFrag() {
      this.confirm_validate_frag = true
    },
    onSubmit() {
      this.$validator.validateAll('settingPasswordForm').then(async result => {
        this.onValidate()
        if (result && !this.confirm_validate) {
          this.$store.dispatch('users/postUpdatePassword', {
            current_password: this.crrent_password,
            new_password: this.new_password
          })
        }
      })
    }
  }
})
